import * as mdb from 'mdb-ui-kit'; // lib 
// import * as mdb from 'mdb-ui-kit/js/mdb.umd.min.js'; // lib

import { Ripple,Popconfirm, initMDB,Tab,Toast, InputMask,Sidenav,Chip, Carousel,ChipsInput, Collapse, Alert, Button, SmoothScroll, PerfectScrollbar, Loading, LazyLoad, InfiniteScroll, Clipboard, Sticky, Dropdown, Lightbox, Stepper, Modal, Select, Input, Autocomplete, Datepicker, Datetimepicker, MultiRangeSlider, Range, Timepicker } from 'mdb-ui-kit';
initMDB({ Lightbox, Popconfirm,Sticky,Tab,Toast, InputMask,Sidenav,Chip, Carousel,ChipsInput, Collapse, Alert, Button, SmoothScroll, PerfectScrollbar, Loading, LazyLoad, InfiniteScroll, Clipboard, Dropdown, Input, Ripple, Modal, Select, Autocomplete, Datepicker, Datetimepicker, MultiRangeSlider, Range, Timepicker });
window.mdb = mdb;
window.Stepper = Stepper;
window.Collapse = Collapse;
window.Dropdown = Dropdown; 
window.InputMask = InputMask;  
window.Modal = Modal;  
window.Toast = Toast;  
window.Select = Select;  
window.Popconfirm = Popconfirm;  
window.Datepicker = Datepicker;  
window.Timepicker = Timepicker;  